module.exports = __webpack_public_path__ + "static/img/egg_g_22.0ae4cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_22.png
// module id = Kbm3
// module chunks = 1